










import Vue from 'vue';
import CookieHelper from '../../helpers/OldCookieHelper';

export default Vue.extend({
  name: `AcceptedCookieRevoke`,
  methods: {
    resetCookieSelection(): void {
      CookieHelper.getAllCookieNames().forEach((cookieName: string): void => {
        CookieHelper.removeCookie(cookieName);
      });
      CookieHelper.removeAll();
      CookieHelper.removeCookie(`_fw_crm_v`, false);
      window.location.reload();
    },
  },
});
